// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "NAAppliedRTUCW." + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"cf7bee","834":"72f6b2"}[chunkId] + ".js";
};